import React from 'react';
import Helmet from 'react-helmet';
import GetComponent from '../utils/getComponent';

/**
 * Home Page
 * @param {object} props Incoming Props
 * @returns {XML} A Home Page
 */
const TermsPage = ({
  data: {
    allContentfulNewsArticle,
    data: {
      edges,
    },
    dataJson,
    site,
  },
}) => {
  let pageComponents = [];
  const showCities = site && site.siteMetadata && site.siteMetadata.showCities;
  if (edges && edges.length > 0 && edges[0].node && edges[0].node.components) {
    pageComponents = edges[0].node.components;
  }
  return (
    <div>
      <Helmet
        title="Deposit Terms"
        meta={
          [{
            name: 'description',
            content: 'Terms and conditions for season ticket deposits.',
          },
          {
            name: 'robots',
            content: 'noindex,nofollow',
          }]
        }
      />
      {
        pageComponents
        && pageComponents.map((component, index) => GetComponent({
          component,
          allContentfulNewsArticle,
          index,
          dataJson,
          showCities,
        }))
      }
    </div>
  );
};
export default TermsPage;
// eslint-disable-next-line
export const pageQuery = graphql `
  query TermsPageQuery {
    site {
      siteMetadata {
        startDate
        title
      }
    }
    allContentfulTeam(filter: { excludeFromSite: { ne: true } }, sort: { fields: [sortOrder], order: ASC }) {
      edges {
        node {
          id
          urlSlug
          cityName
          cityAbbreviation
          teamLogo {
            file {
              url
            }
          }
          teamName
          teamTabBackground {
            file {
              url
            }
          }
          excludeFromSite
          ticketMasterLink
          ticketMasterButtonText
        }
      }
    }
    allContentfulNewsArticle(
      filter: { excludeFromSite: { ne: true } }
      sort: { fields: [date, updatedAt], order: DESC }
    ) {
      edges {
        node {
          id
          image {
            file {
              url
              details {
                image {
                  width
                  height
                }
              }
            }
            resolutions {
              ...GatsbyContentfulResolutions
            }
          }
          videoStill {
            file {
              url
            }
          }
          articleSlug
          title
          source
          externalUrl
          date
          updatedAt
          excludeFromSite
          childContentfulNewsArticleArticleSummaryTextNode {
            childMarkdownRemark {
              excerpt(pruneLength: 90)
            }
          }
          featured
          tags
        }
      }
    }
    data: allContentfulPage(filter: { contentfulid: { eq: "termspage" } }) {
      edges {
        node {
          components {
            __typename
            ... on ContentfulFaqGroup {
              title
              titleImage {
                file {
                  url
                }
              }
              faQs {
                question
                answer
              }
            }
            ... on ContentfulTickets {
              __typename
              title
              subtitle
              includeSelector
              ticketQuantityLimit
              enableModal
              modalTitle
              modalContent {
                childMarkdownRemark {
                  html
                }
              }
              copy: description {
                childMarkdownRemark {
                  html
                }
              }
              background {
                file {
                  url
                }
              }
            }
            ... on ContentfulNewsArticleGroup {
              title
              titleImage {
                file {
                  url
                }
              }
              articles {
                ... on ContentfulNewsArticle {
                  id
                  videoId
                  image {
                    file {
                      url
                      details {
                        image {
                          width
                          height
                        }
                      }
                    }
                    resolutions {
                      ...GatsbyContentfulResolutions
                    }
                  }
                  videoStill {
                    file {
                      url
                    }
                  }
                  articleSlug
                  title
                  source
                  externalUrl
                  date
                  updatedAt
                  excludeFromSite
                  childContentfulNewsArticleArticleSummaryTextNode {
                    childMarkdownRemark {
                      excerpt(pruneLength: 90)
                    }
                  }
                }
              }
              backgroundImage {
                file {
                  url
                }
              }
            }
            ... on ContentfulTitleAndRichText {
              title
              titleImage {
                file {
                  url
                }
              }
              richTextDescription {
                childMarkdownRemark {
                  html
                }
              }
              textAlignment
              backgroundImage {
                file {
                  url
                }
              }
              ctaLink
              ctaText
            }
            ... on ContentfulProfileGroup {
              title
              titleImage {
                file {
                  url
                }
              }
              backgroundImage {
                file {
                  url
                }
              }
              profiles {
                ... on ContentfulProfile {
                  firstName
                  lastName
                  title
                  profilePicture {
                    file {
                      url
                      details {
                        image {
                          width
                          height
                        }
                      }
                    }
                    resolutions {
                      ...GatsbyContentfulResolutions
                    }
                  }
                  quote {
                    childMarkdownRemark {
                      html
                    }
                  }
                  description {
                    childMarkdownRemark {
                      html
                    }
                  }
                  twitterHandle
                }
              }
            }
            ... on ContentfulMediaKit {
              titleImage {
                file {
                  url
                }
              }
              titleImageAltText
              subtitle
              childContentfulMediaKitDescriptionTextNode {
                childMarkdownRemark {
                  html
                }
              }
              firstKitDownload {
                file {
                  fileName
                  url
                }
              }
              firstKitDownloadText
              secondKitDownload {
                file {
                  fileName
                  url
                }
              }
              secondKitDownloadText
              backgroundImage {
                file {
                  fileName
                  url
                }
              }
            }
            ... on ContentfulHeroCarousel {
              carouselSlides {
                __typename
                ... on ContentfulHeroPromo {
                  localFileUrl
                  ctaUrl
                  hideControls
                  backgroundImage {
                    file {
                      url
                    }
                  }
                }
                ... on ContentfulVideo {
                  __typename
                  youtubeVideoId
                  displayTitle
                  subtitle
                  posterImageOverwrite {
                    file {
                      url
                    }
                  }
                  youtubeVideoId
                  autoPlay
                }
                ... on ContentfulNewsArticle {
                  title
                  subtitle
                  articleSlug
                  landscapeImage {
                    file {
                      url
                    }
                  }
                }
              }
            }
            ... on ContentfulVideo {
              __typename
              youtubeVideoId
              posterImageOverwrite {
                file {
                  url
                }
              }
              youtubeVideoId
              autoPlay
            }
            ... on ContentfulDividerPromo {
              __typename
              text
              showSocial
              videoId
              image {
                file {
                  url
                  details {
                    image {
                      height
                      width
                    }
                  }
                }
              }
            }
            ... on ContentfulTwitter {
              __typename
              id
              titleImage {
                file {
                  url
                }
              }
              customHashtag
              tweetPretext
              childContentfulTwitterDescriptionTextNode {
                childMarkdownRemark {
                  html
                }
              }
              background {
                file {
                  url
                }
              }
              placeholder
              buttonText
            }
            ... on ContentfulSignUp {
              __typename
              titleImage {
                file {
                  url
                }
              }
              subtitle
              childContentfulSignUpDescriptionTextNode {
                childMarkdownRemark {
                  html
                }
              }
              placeholderEmail
              placeholderFirstName
              placeholderLastName
              buttonText
              background {
                file {
                  url
                }
              }
              cityReference {
                cityName
              }
            }
            ... on ContentfulSignUp {
              __typename
              titleImage {
                file {
                  url
                }
              }
              subtitle
              childContentfulSignUpDescriptionTextNode {
                childMarkdownRemark {
                  html
                }
              }
              placeholderEmail
              placeholderFirstName
              placeholderLastName
              buttonText
              background {
                file {
                  url
                }
              }
              cityReference {
                cityName
              }
            }
            ... on ContentfulCtaPromo {
              __typename
              title
              description
              ctaLink
              ctaDisplayText
              longDescription {
                childMarkdownRemark {
                  html
                }
              }
              backgroundImage {
                file {
                  url
                }
              }
            }
            ... on ContentfulLeftAlignedPromo {
              __typename
              title
              subtitle
              swapAlignment
              childContentfulLeftAlignedPromoDescriptionTextNode {
                childMarkdownRemark {
                  html
                }
              }
              modalContent {
                childMarkdownRemark {
                  html
                }
              }
              ctaLink
              ctaText
              backgroundImage {
                file {
                  url
                }
              }
              rightAlignedImage {
                file {
                  url
                }
              }
            }
            ... on ContentfulFeaturedNewsAndCarousel {
              __typename
              title
              titleImage {
                file {
                  url
                }
              }
              featuredArticle {
                id
                articleSlug
                landscapeImage {
                  file {
                    url
                    details {
                      image {
                        width
                        height
                      }
                    }
                  }
                  resolutions {
                    ...GatsbyContentfulResolutions
                  }
                }
                title
                source
                externalUrl
                date
                updatedAt
                childContentfulNewsArticleArticleSummaryTextNode {
                  childMarkdownRemark {
                    excerpt(pruneLength: 100)
                  }
                }
              }
              tagsToPull
            }
            ... on ContentfulFaqGroup {
              title
              titleImage {
                file {
                  url
                  details {
                    image {
                      width
                      height
                    }
                  }
                }
                resolutions {
                  ...GatsbyContentfulResolutions
                }
              }
              faQs {
                question
                answer
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/deposit-terms.js